/* ---------- 2. pricing rich text → targets ---------- */

import { $, $$, clean } from '../lib/dom';

const PRICING_TYPES = ['player', 'spectator'];
const show = (node: HTMLElement) => {
  node.hidden = false;
  node.style.display = '';
};

const renderPricingType = (section: HTMLElement, type: string) => {
  const hook = `data-pricing-${type}`;
  const find = (key: string) => $(`[${hook}="${key}"]`, section) ?? $(`[${hook}="${key}"]`); // section first, then page
  const source = find('source');
  if (!source) return;
  const fallbackHref = find('link-0')?.getAttribute('href');

  $$('p', source).forEach((p, i) => {
    const targets = (key: string) => $$(`[${hook}="${key}-${i + 1}"]`, section);
    const links = targets('link');
    const line = clean(p.textContent ?? '');

    if (line === '-') return links.forEach((node) => node.remove()); // "-" removes the whole item
    const titles = targets('title');
    const prices = targets('price');
    [...links, ...titles, ...prices].forEach(show);
    if (!line) return; // empty line keeps the designed item as-is

    const sep = line.indexOf(':');
    const title = sep > -1 ? clean(line.slice(0, sep)) : '';
    const price = clean(sep > -1 ? line.slice(sep + 1) : line);
    const href = $('a', p)?.getAttribute('href') || fallbackHref;

    if (title && title !== '-') titles.forEach((node) => (node.textContent = title));
    if (price && price !== '-') prices.forEach((node) => (node.textContent = price));
    if (href) links.forEach((node) => node.setAttribute('href', href));
  });
};

export const renderPricing = () =>
  $$('[data-section-pricing]').forEach((section) => PRICING_TYPES.forEach((type) => renderPricingType(section, type)));
